import React, { useEffect, useRef, useState } from 'react';

import { message } from 'antd';
import { InputOTP } from 'antd-input-otp';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { resetTwoFa } from '../../store/user/user.slice';
import { transport } from '../../utils/constants';
import { getToken } from '../../utils/helper';
import IosModal from '../Common/IosModal/IosModal';
import { GoogleAuthenticatorClient } from '../../generated/mlmbox/client/google_authenticator/google_authenticator.client';
import { Status_GoogleAuthenticatorVerifiedCode } from '../../generated/mlmbox/types/status';

const DeactiveTwoFA: React.FC<{ closeBtn: Function }> = ({ closeBtn }) => {
    const [fetching, setFEtching] = useState(false);

    const { t } = useTranslation();
    const twoFAClient = new GoogleAuthenticatorClient(transport);

    const dispatch = useDispatch();

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 300);
    }, []);

    function closing() {
        if (!closeBtn) return;
        // setClose(true);
        setTimeout(() => closeBtn(), 200);
    }

    function codeComplete(code: string[]) {
        setFEtching(true);
        if (!code || code.length < 6) return;

        twoFAClient
            .deactivate({ verifiedCode: code.join('') }, { meta: { authorization: getToken() } })
            .then(({ status, response }) => {
                if (status.code === 'OK') {
                    switch (response.status) {
                        case Status_GoogleAuthenticatorVerifiedCode.APPROVED:
                            dispatch(resetTwoFa(response.result));
                            message.warning(t('twoFA.off_success'));
                            closing();
                            setFEtching(false);

                            return;
                        case Status_GoogleAuthenticatorVerifiedCode.UNKNOWN:
                            message.error(t('errors.unknown'));
                            closing();
                            setFEtching(false);
                            return;
                        case Status_GoogleAuthenticatorVerifiedCode.REJECTED:
                            message.error(t('errors.err_twoFA_off'));
                            closing();
                            setFEtching(false);
                            return;
                        case Status_GoogleAuthenticatorVerifiedCode.WRONG_CODE:
                            message.error(t('errors.wrong_code'));
                            setFEtching(false);
                            return;
                    }
                }
            });
    }

    return (
        <IosModal
            cancel={() => {
                closeBtn();
            }}
            cancelBtnTitle={t('modals.ios.header.btns.cancel')}
            title={t('modals.ios.header.titles.code')}>
            <InputOTP
                inputType="numeric"
                type="tel"
                ref={inputRef}
                inputStyle={{
                    opacity: fetching ? 0.5 : 1,
                    userSelect: 'none',
                    background: 'var(--ln-bg)',
                    border: '1px solid #5E88C7',
                    color: '#8590AC',
                    fontSize: '20px',
                    fontFamily: 'Unbounded',
                }}
                autoSubmit={codeComplete}
            />
        </IosModal>
    );
};

export default DeactiveTwoFA;
